import { arrayOf, Schema } from 'normalizr';


const SITE_FOOTER_LINK_PAGE_CONTENT_SCHEMA = new Schema('siteFooterLinksPagesContent');

const SITE_FOOTER_LINK_PAGE_SCHEMA = new Schema('siteFooterLinksPages');
SITE_FOOTER_LINK_PAGE_SCHEMA.define({
  items: arrayOf(SITE_FOOTER_LINK_PAGE_CONTENT_SCHEMA),
});

export const SITE_FOOTER_LINK_PAGES_SCHEMA = {
  pages: arrayOf(SITE_FOOTER_LINK_PAGE_SCHEMA),
};
